import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { buscarMedicos, gravarMedico } from 'services/usuarios';

export function useMedicoSearch() {
  const [query, setQuery] = useState('');
  const [options, setOptions] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => () => clearTimeout(debounceRef.current), []);

  const buscar = (valor) => {
    setQuery(valor);
    clearTimeout(debounceRef.current);

    const isCodigo = /^\d+$/.test(valor);
    if (!isCodigo && valor.length < 3) {
      setOptions([]);
      setShowDropdown(false);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      setIsSearching(true);
      try {
        const res = await buscarMedicos(valor);
        const lista = Array.isArray(res) ? res : (res?.medicos ?? []);
        setOptions(lista);
        setShowDropdown(lista.length > 0);
      } catch {
        setOptions([]);
        setShowDropdown(false);
      } finally {
        setIsSearching(false);
      }
    }, 350);
  };

  const localizarPorCodigo = async (codigo, callbackSucesso) => {
    if (!codigo?.trim()) {
      callbackSucesso({ codMed: '', nome: '' });
      return;
    }
    try {
      const res = await buscarMedicos(codigo);
      const lista = Array.isArray(res) ? res : (res?.medicos ?? []);
      if (!lista.length) {
        toast.warning('Médico não encontrado.');
        return;
      }
      callbackSucesso({ codMed: String(lista[0].codMed), nome: lista[0].nome });
    } catch {
      toast.error('Erro ao localizar médico.');
    }
  };

  return {
    query,
    setQuery,
    options,
    setOptions,
    isSearching,
    showDropdown,
    setShowDropdown,
    buscar,
    localizarPorCodigo,
  };
}

export function useCadastroMedico(codFunc) {
  const [isSaving, setIsSaving] = useState(false);

  const salvar = async (dados, onSuccess) => {
    if (!dados.nome?.trim()) {
      toast.warning('Informe o nome do médico.');
      return;
    }
    setIsSaving(true);
    try {
      const payload = { ...dados, tipo: 'Externo', codFunc };
      const res = await gravarMedico(payload);
      toast.success(res.mensagem || 'Médico cadastrado com sucesso!');
      onSuccess?.(res);
    } catch (err) {
      toast.error(err?.response?.data?.mensagem || 'Erro ao cadastrar médico.');
    } finally {
      setIsSaving(false);
    }
  };

  return { salvar, isSaving };
}
